import { tWorkspaceContext } from './Workspace.types';
import { eChannelType } from 'src/providers/SocketsProvider/Sockets.enums.ts';

export const WORKSPACE_INITIAL_STATE: tWorkspaceContext = {
  currentWorkspaceId: '',
  setCurrentWorkspaceId: () => {},
  currentWorkspace: undefined,
  setCurrentWorkspace: () => {},
  onCreateWorkspaceSubmit: async () => {
    return {
      code: 0,
      data: {
        name: '',
        id: '',
      },
      errors: [],
      message: '',
      success: false,
    };
  },
  handleWorkspaceUpdate: () => {},
  workspaceInfo: undefined,
  isLoadingWorkspaceInfo: false,
  isRoleResolved: false,
  updateWorkspaceInfo: async () => {
    return {
      success: false,
      data: {
        workspace: {
          id: '',
          name: '',
        },
      },
    };
  },
  addUserToWorkspace: async () => {
    return {
      auth_id: '',
      user_uuid: '',
      new_user: false,
      userArray: {
        uuid: '',
        auth_id: '',
        name: '',
        first_name: '',
        email: '',
        autoAssign: false,
        goal: 0,
        funnels: [],
        new: '',
      },
    };
  },
  resendUserInvitation: async () => {
    return {
      success: false,
      message: '',
      code: 0,
    };
  },
  handleWorkspaceUserUpdated: () => {},
  handleWorkspaceUserUpdate: () => {},
  updateWorkspaceUserInbox: async () => {},
  deleteWorkspaceUser: async () => {},
  unlinkWorkspaceUser: async () => {},
  updateWorkspaceUser: () => {},
  checkIfWorkspaceHasMoreThan90Days: () => false,
  workspaces: undefined,
  setWorkspaces: () => {},
  getAllWorkspaces: async () => {},
  setWorkspaceSaleSource: () => {},
  workspaceSaleSource: undefined,
  canSeeWapiIntegration: false,
  hasLoadedWapiAccessException: false,
  canSendBulkMessages: false,
  activateWorkspace: () => {},
  getDisplayIntegration: () => eChannelType.WHATSAPP_WEB,
};
